import { detectSingleFace, fetchImage, nets, TinyFaceDetectorOptions }  from '@vladmandic/face-api'

// import { post } from 'services/api'

// async function imageUploaded(file, token, cb) {
//   await cb(
//     file.replace("data:", "").replace(/^.+,/, ""),
//     token,
//   )
// }

// // Salva imagem no backend para debugar a selfie capturada pelo disposivo.
// const saveImage = async (base64_file, token) => {
//   await post({
//     url: '/save_image_test',
//     token,
//     data: { base64: base64_file },
//   })
// }

export const loadModels = (model_url) => {
  return Promise.all([
    nets.tinyFaceDetector.loadFromUri(model_url),
    nets.faceLandmark68Net.loadFromUri(model_url),
    nets.faceRecognitionNet.loadFromUri(model_url),
    nets.faceExpressionNet.loadFromUri(model_url),
  ])
}

export async function getFullFaceDescription(
  blob,
  token,
  withFaceLandmarks = false,
) {

  const scoreThreshold = 0.3
  const inputSize = 512
  const OPTIONS = new TinyFaceDetectorOptions({
    inputSize,
    scoreThreshold,
  })

  // Salva imagem no backend para debugar a selfie capturada pelo disposivo.
  // imageUploaded(blob, token, (base64_file, token) => {
  //   return saveImage(base64_file, token)
  // })

  const img = await fetchImage(blob)
  let fullDesc = null

  if (withFaceLandmarks) {
    fullDesc = await detectSingleFace(img, OPTIONS).withFaceLandmarks()
  } else {
    fullDesc = await detectSingleFace(img, OPTIONS)
  }

  return fullDesc
}
